import { NavLink } from "react-router-dom";

const CATS = [
  { to: "/tratamento-de-ruidos", label: "Ruídos (12)" },
  { to: "/isolamento-termoacustico", label: "Isolamento (9)" },
  { to: "/diagnostico", label: "Diagnóstico (12)" },
  { to: "/pacotes", label: "Pacotes (2)" },
];

export const CategoryTabs = () => (
  <div className="-mx-4 mb-8 overflow-x-auto border-b border-slate-800 px-4 sm:mx-0 sm:px-0" data-testid="category-tabs">
    <div className="flex min-w-max gap-1 py-2">
      {CATS.map((c) => (
        <NavLink key={c.to} to={c.to} data-testid={`category-tab-${c.to.slice(1)}`}
          className={({ isActive }) => `whitespace-nowrap px-3 py-2 font-heading text-xs font-bold uppercase tracking-wide transition-colors ${isActive ? "bg-[#DC2626] text-white" : "border border-slate-700 text-slate-300 hover:text-white"}`}>
          {c.label}
        </NavLink>
      ))}
    </div>
  </div>
);
